/* Same-tab navigation context only. The server still authorizes every claim. */
(() => {
  const key = 'pp:prepaid-gift:v1';
  const validToken = value => /^[A-Za-z0-9_-]{22}$/.test(value || '');
  const productHandle = path => /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([a-z0-9-]+)\/?$/.exec(path)?.[1];
  const params = new URLSearchParams(location.search);
  const fragment = new URLSearchParams(location.hash.slice(1));
  const explicit = fragment.get('gift_claim') || params.get('gift_claim');
  let record = null;
  try {
    const saved = JSON.parse(sessionStorage.getItem(key));
    if (saved?.version === 1 && validToken(saved.token) && typeof saved.path === 'string' && typeof saved.handle === 'string' && productHandle(saved.path) && productHandle(saved.path) === saved.handle) record = saved;
  } catch { /* Storage can be unavailable; explicit gift links still work. */ }
  if (validToken(explicit) && productHandle(location.pathname)) {
    record = {version:1, token:explicit, path:location.pathname, handle:productHandle(location.pathname)};
    try { sessionStorage.setItem(key, JSON.stringify(record)); } catch {}
  } else if (fragment.has('gift_claim') || params.has('gift_claim')) {
    // Never substitute a different saved gift for an explicitly supplied link.
    record = null;
  }
  window.PPGiftClaimContext = {
    tokenForProduct: handle => record?.handle === handle ? record.token : null,
    tokenForPage: () => record && productHandle(location.pathname) === record.handle ? record.token : null,
    urlForProduct: handle => record?.handle === handle ? `${record.path}#gift_claim=${record.token}` : null,
    clear(token) {
      if (record?.token !== token) return;
      try {
        const saved = JSON.parse(sessionStorage.getItem(key));
        if (saved?.token === token) sessionStorage.removeItem(key);
      } catch {}
      record = null;
    },
  };
})();
